import { createContext, useContext } from 'react'

// Active drag context: { item, fromZoneId } | null
export const ActiveDragContext = createContext(null)

export function useActiveDrag() {
  return useContext(ActiveDragContext)
}

// Drop-zone context: { isOver, canDrop, isActive }
//   isActive = isOver && canDrop && active drag is from a different zone
export const DropZoneContext = createContext({ isOver: false, canDrop: true, isActive: false })

export function useDropZone() {
  return useContext(DropZoneContext)
}
